<template>
  <div class="Thumbnail"
    :style="styles"
    @mouseenter="hover = true"
    @mouseleave="hover = false">

    <div class="Thumbnail-imageContainer"
      :style="imageContainerStyles">

      <crop v-if="ratio">

        <image-component v-bind="image" />

      </crop>

      <image-component v-if="!ratio" v-bind="image" />

    </div>

    <div class="Thumbnail-tags"
      v-if="tags || button">

      <tag class="Thumbnail-button"
        v-if="button"
        v-bind="button"
        :highlighted="hover"
        large />

      <tag class="Thumbnail-tag"
        v-for="(tag, index) in tags"
        v-if="tag"
        :key="index"
        v-bind="tag"
        :highlighted="hover" />

    </div>

  </div>
</template>

<script>
import { assign } from 'lodash'

export default {
  name: 'Thumbnail',

  props: {
    ratio: {
      type: Array
    },
    image: {
      type: Object
    },
    tags: {
      type: Array, Object
    },
    button: {
      type: [Object, Boolean],
      default: false
    }
  },

  data () {
    return {
      /**
       * Hover state
       * @type {Boolean}
       */
      hover: false
    }
  },

  computed: {
    /**
     * Ratio expressed as a decimal
     * @return {Number}
     */
    ratioDecimal () {
      if (!this.ratio) return
      return this.ratio[1] / this.ratio[0]
    },

    /**
     * Ratio expressed as a percentage
     * @return {Number}
     */
    ratioPercentage () {
      if (!this.ratio) return
      return this.ratioDecimal * 100
    },

    /**
     * Styles for the main element
     * @return {Object}
     */
    styles () {
      let styles = {}

      if (this.ratio) {
        styles = assign(styles, {
          'padding-top': `${this.ratioPercentage}%`
        })
      }

      return styles
    },

    /**
     * Image container element styles
     * @return {[type]} [description]
     */
    imageContainerStyles () {
      let styles = {}

      if (this.ratio) {
        styles = assign(styles, {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        })
      }

      return styles
    }
  }
}
</script>

<style>
@import 'properties';

.Thumbnail {
  position: relative;
}

.Thumbnail-image {
  border: 2px solid hotpink;
}

.Thumbnail-tags {
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  padding: 12px;
  pointer-events: none;
}

.Thumbnail-tag + .Thumbnail-tag {
  margin-left: var(--unit-025);
}
</style>



// WEBPACK FOOTER //
// Thumbnail.vue?a5c227ce